import { lazy } from 'react';

const CharityCIFRoute = lazy(
  () => import(/* webpackChunkName: "CharityCIF" */ '../components/steps/cif-step/CIF'),
);

export default CharityCIFRoute;
